import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import type * as rxjs from 'rxjs'

import * as gql from '../functional-usage/gql'

import type { Context } from './types'

/**
 * API used by the records bulk functional usage workflow
 */
@ngCore.Injectable()
export class Api {
  /**
   * Applies one functional usage to every record in the context.
   */
  public update({
    context,
    updates,
  }: Api.Update.Params): rxjs.Observable<undefined> {
    return gql.mutations.bulkUpdateSpaceRecordFunctionalUsage.executor({
      ...context,
      update: gql.inputs.recordUpdates.TRANSFORMER.getGqlFrom(updates),
    })
  }
}

export namespace Api {
  export namespace Update {
    /** {@link Context}, with the functional usage to apply */
    export interface Params {
      readonly context: Context
      readonly updates: ents.extra.space.Record.FunctionalUsage.Update
    }
  }
}
